<template>
  <div>
    <div class="step-main">
      <div class="header">
        <div>{{pdata.stepsIdnum}}</div>
        <div>
          <div style="width: 50%">{{ pdata.stepsTitle }}</div>
          <div style="width: 50%;" v-show="isShowDate"><span style="width: 100%; text-align: right">{{pdata.stepsTime }}</span></div>
        </div>
      </div>
      <van-list
          v-model="loading"
          :finished="finished"
          @load="onLoad"
          class="step-body"
      >
        <van-cell v-for="(item, i) in filterKeys(list)" :key="i" :title="item.orderOperationKey.indexOf('verifyCode') != -1||item.orderOperationKey.indexOf('Checked') != -1?'':item.orderOperationKey">
          <template #default>
            <span :style="getStyle(pdata, item)">{{ item.orderOperationValue }}</span>
          </template>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepComponent",
  props: ["pdata", "list", "active"],
  data() {
    return {
      //list: [],
      loading: false,
      finished: false,
      color:{color: '#969799'}
    };
  },
  mounted() {
    console.log(this.pdata, this.list)
  },
  computed:{
    filterKeys(){
      return function (lists) {
        return lists.filter(item => item.orderOperationValue!=null&&!item.orderOperationValue.includes("限制")&&!item.orderOperationValue.includes("商家自主审核"));
      }
    },
    getStyle(){
      return function (item, value) {
        if (this.active == -1){
          return this.color;
        }else if (item.stepsIdnum == 2){
          return {color: 'red'}
        }
        if (value.orderOperationValue == "商家一般24小时确认发货"
            || value.orderOperationValue == "此单为普通任务"
            || value.orderOperationValue == "商家一般24小时确认评价"){
          return {color: 'red'}
        }

      }
    }
  },
  methods: {
    isShowDate(){
      return this.pdata.dateTime == null  ? false : true;
    },
    onLoad() {
      this.loading = false;
      this.finished = true
      /*
      if (this.list != null ){
        // 加载状态结束
        this.loading = false;
        this.finished = true;
      }

       */
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      // setTimeout(() => {
      //   for (let i = 0; i < 2; i++) {
      //     this.list.push(this.list.length + 1);
      //   }
      //
      //   // 加载状态结束
      //   this.loading = false;
      //
      //   // 数据全部加载完成
      //   if (this.list.length >= 3) {
      //     this.finished = true;
      //   }
      // }, 1000);
    },
  },
}
</script>

<style lang="scss" scoped>
.step-main {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  width: 100%;
  .header{
    display: flex;
    flex-flow: row nowrap;
    justify-content: left;
    div:first-child{
      width: 5%;
    }
    div{
      width: 95%;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
    }
  }
}
</style>
